import { LoginRequest } from '../../../models/requests/login.request';
import axios from '../../axios';

/**
 * Basarili giriste backend 204 doner ve govde bostur; JWT, HttpOnly cerez
 * (hf_at) olarak Set-Cookie ile gelir. Basari kriteri 2xx status'tur.
 *
 * `skipForcedLogout`: parola suresi dolmus kullanicida bu uc 401 + code
 * dondurur; bu dal, sayfa zaten girisiz oldugu icin global zorla-cikis/
 * login-yonlendirme akisina girmemeli, dallanmayi LoginPage kendi yapar.
 *
 * `skipGlobalErrorModal`: captcha zorunlulugu 428 ile geliyor ve LoginPage
 * istegi sessizce captcha token'i ile tekrarliyor; jenerik hata modali
 * acilirsa kullanici gorunmez bir dogrulama icin hata gormus olur. Diger
 * login hatalari da LoginPage icinde mesaj olarak gosteriliyor.
 */
export default async function loginRequest(
  request: LoginRequest
): Promise<void> {
  await axios.post(
    `${process.env.REACT_APP_BASE_URL}/auth/hedef/login`,
    request,
    { skipForcedLogout: true, skipGlobalErrorModal: true }
  );
}
